import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import Prijzen from "./sections/Prijzen";
import Contactformulier from "./sections/Contactformulier";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <Prijzen />
      <Contactformulier />
      <Footer />
    </div>;
}